module.exports = __webpack_public_path__ + "static/img/qiaohu.b7b0480e.jpg";